const ADD_TO_BE_UPDATED = "ADD_TO_BE_UPDATED"
const DELETE_TO_BE_UPDATED = "DELETE_TO_BE_UPDATED"
const CHANGE_NAME_TO_BE_UPDATED = "CHANGE_NAME_TO_BE_UPDATED"
const CHANGE_ORDER_TO_BE_UPDATED = "CHANGE_ORDER_TO_BE_UPDATED"

export {ADD_TO_BE_UPDATED, DELETE_TO_BE_UPDATED, CHANGE_NAME_TO_BE_UPDATED, CHANGE_ORDER_TO_BE_UPDATED}